export const DOWNLOAD_APP_BANNER_DISMISSED_STORAGE_KEY = 'appBannerDismissed';

export const shouldShowDownloadAppBanner = (): boolean => {
  // In the UI we need it to decide if it's visible so we invert the value from sessionStorage
  const isHidden = sessionStorage.getItem(DOWNLOAD_APP_BANNER_DISMISSED_STORAGE_KEY);
  return !isHidden;
};

export const hideDownloadAppBannerSessionStorage = () => {
  if (window && sessionStorage) {
    sessionStorage.setItem(DOWNLOAD_APP_BANNER_DISMISSED_STORAGE_KEY, JSON.stringify(true));
  }
};
